<template>
  <div style="display: flex; flex-wrap: wrap">
    <div :style="{ width: (100 / (columns /* + 1 */)).toFixed(3) + '%' }" v-for="episode in episodes" :key="episode.id">
      <vs-card :style="{ margin: .25+'rem' }"
          @click="!(episode.show_url && episode.season_number) ? goToLink(`https://videnti.co/watch/${seriesUrl}/${seasonNumber}/${episode.episode_number}`) : goToLink(`https://videnti.co/watch/${episode.show_url}/${episode.season_number}/${episode.episode_number}`)">
        <template #title>
          <div class="title-container">
            <h3 class="episode-name-cut">{{episode.name}}</h3>
          </div>
        </template>
        <template #img>
          <img v-if="episode.thumbnail != null || episode.thumbnail === ''" :src="episode.thumbnail" alt="" @error="imageUrlAlt" width="1080px"><img v-else :src="`https://i.imgur.com/Zx6wTMp.png`" alt="" @error="imageUrlAlt" width="1080px">
          <progress v-if="episode.seenStatus === 2"
                    :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :aria-valuenow="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
                    :value="(episode.durationStatus === undefined) ? 0 : getSecondsFromISO(episode.durationStatus)"
          ></progress>
          <progress v-if="episode.seenStatus === 1"
                    :aria-valuemax="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :max="episode.seconds + episode.minutes*60 + episode.hours*60*60"
                    :aria-valuenow="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
                    :value="episode.seconds + episode.minutes*60 + episode.hours*60*60 + 1"
          ></progress>
        </template>
        <template #text>
          <p>
            {{ episode.hours ? episode.hours + ":" : "" }}{{ (episode.minutes && episode.minutes !== 0) && (episode.seconds && episode.seconds !== 0 ) ? episode.minutes.zeroPad() + ":" + episode.seconds.zeroPad() + " ·" : "" }} {{ getVideoType(episode.type, true) }} {{ episode.released ? "· Estrenado el " + $luxonDateTime.fromISO(episode.released).toLocaleString($luxonDateTime.DATE_SHORT) : "" }}
          </p>
        </template>
        <template #interactions>
          <vs-button v-if="seriesName || episode.show_name" class="btn-chat" shadow style="background: #195bff !important;" @click.stop="openShowInfo ? openShowInfo(null, episode.show_name, episode.show_url) : goToLink(`https://videnti.co/watch/${seriesUrl}`)">
            <span class="span"> {{seriesName ? seriesName : episode.show_name}} </span>
          </vs-button>
          <vs-button class="btn-chat" shadow style=""> <!-- background: rgba(var(--vs-text), 1); color: rgba(var(--vs-background), 1); -->
            <span v-if="episode.episode_number_custom">{{ episode.episode_number_custom }}</span>
            <span v-else-if="showSeasonNumber">
              {{ $t('general.season_no_episode_no_short', { season: (seasonNumber ? seasonNumber : episode.season_number), episode: episode.episode_number }) }}
              T{{seasonNumber ? seasonNumber : episode.season_number}}E{{episode.episode_number}}
            </span>
            <span class="span" v-else>{{ $t("general.episode_no_short", { episode: episode.episode_number }) }}</span>
          </vs-button>
        </template>
      </vs-card>
    </div>
  </div>
</template>

<script>
import {goToLink} from "@/utils/helpers";

export default {
  name: "EpisodesGrid",
  props: ['columns', 'episodes', 'seriesUrl', 'seriesName', 'seasonNumber', 'showSeasonNumber', 'openShowInfo'],
  methods: {
    goToLink,
    imageUrlAlt(event) {
      event.target.src = "https://storage.googleapis.com/balde-1/various/placeholders/noimg_x.png"
    },
    getSecondsFromISO(input) {
      if (input === null) return 0;
      return this.$temporal.Duration.from(input).total({ unit: 'second' });
    },
  }
}
</script>

<style scoped lang="scss">
.title-container {
  h1, h2, h3, h4 {
    font: {
      weight: 600;
      size: 1rem;
    }
  }
}

progress {
  appearance: none;
  position: absolute;
  width: 100%;
  height: 0.5rem;
  left: 0; bottom: 0;
  overflow: hidden;
  color: rgb(var(--vs-primary));

  &::-webkit-progress-value { background-color: rgb(var(--vs-primary)); }
}
</style>
